import { exhaustCheck } from './kameleoonError';
import { KameleoonResponseType, RequestType } from './requester';
import { SimulateRequestDataType } from './types';

/**
 * KameleoonUtils - a class containing static Kameleoon helper methods
 * */
export class KameleoonUtils {
  /**
   * @method simulateSuccessRequest - a method to simulate a successful request based on request type, primarily used for `IExternalRequester` implementations
   *
   * @param {RequestType} requestType - request type
   * @param {SimulateRequestDataType[RequestType]} data - simulate data type for request
   * */
  public static simulateSuccessRequest<T extends RequestType>(
    requestType: T,
    data: SimulateRequestDataType[T],
  ): Promise<KameleoonResponseType> {
    switch (requestType) {
      case RequestType.Tracking:
        return new Promise((resolve) => {
          const response: KameleoonResponseType = {
            status: 204,
            json: () => new Promise((r) => r(null)),
            text: () => new Promise((r) => r('')),
            ok: true,
          };

          resolve(response);
        });
      case RequestType.Configuration:
      case RequestType.RemoteData:
        return new Promise((resolve) => {
          const response: KameleoonResponseType = {
            status: 200,
            json: () => new Promise((r) => r(data)),
            text: () => new Promise((r) => r('')),
            ok: true,
          };

          resolve(response);
        });
      default:
        exhaustCheck(requestType);
    }
  }

  /**
   * @method getCookieValue - a method to get a cookie value by key from a cookie string, primarily used for `IExternalVisitorCodeManager` implementations
   *
   * @param {string} cookie - cookie string
   * @param {string} key - cookie key
   * @returns {string | null} cookie value or null if not found
   * */
  public static getCookieValue(cookie: string, key: string): string | null {
    const pairs = cookie.split('; ');
    const pair = pairs.find((pair) => {
      const [pairKey, pairValue] = pair.split('=');

      return pairKey === key && pairValue !== '';
    });

    if (pair) {
      return pair.split('=')[1];
    }

    return null;
  }
}
